import React, { useEffect } from "react";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import TextArea from "antd/es/input/TextArea";
import { connect, useSelector } from "react-redux";
import {
  doOvertimeApproval,
} from "../../../../../redux/overtime/overtimeState";
import { MODULE_OVERTIME_REQUESTS } from "variables/constants";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { formatDateRange } from "utils/index";
import {
  CircleCheck, CircleX
} from "lucide-react"

export const OTS_APPROVED = 67;
export const OTS_DECLINED = 68;

const OvertimeApprovalForm = ({
  recordData,    
  mode = "edit",
  action,     
  doApproval,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const authUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (recordData) {
      form.setFieldsValue({
        ots_id: recordData.ots_id,
        ots_status_id: recordData.ots_status_id,
      });
    }
  }, [recordData, form]);

  const onSubmit = (formData) => {
    try {
      const overtimeId =
        formData.ots_id ?? recordData?.ots_id;

      const timecardId =
        formData.ots_timecard_id ?? recordData?.ots_timecard_id;

      if (!overtimeId || overtimeId <= 0) return;

      const typeId =
        action === "Approve"
          ? OTS_APPROVED
          : action === "Reject"
          ? OTS_DECLINED
          : null;

      if (!typeId) return;

      const payload = {
        ...formData,
        recordId: overtimeId,
        typeId,
        ots_timecard_id: timecardId,
      };
      doApproval(payload);
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  const submitIcon = action === "Approve" ? <CircleCheck /> : <CircleX />;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 text-[13px] py-4">
        <div className="pl-4">
          <p className="text-slate-700 mb-1 dark:text-slate-200">Date</p>
           <span className="font-medium">{formatDateRange(recordData?.ots_date_from)}</span>
        </div>
        <div>
          <p className="text-xs text-slate-700 mb-1 dark:text-slate-200">Overtime Hours</p>
          <span className="text-[13px] font-medium tracking-normal">{recordData?.duration_string}</span>
        </div>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <FormItem name="ots_id" hidden>
          <Input type="hidden" />
        </FormItem>

        <FormItem name="ots_timecard_id" hidden>
          <Input type="hidden" />
        </FormItem>
        
        <div className="grid grid-cols-1 px-4">
          <FormItem
            name="ots_notes"
            label={
              action === "Reject"
                ? "Reason for Rejection"
                : "Additional Notes (Optional)"
            }
            rules={
              action === "Reject"
                ? [requiredField()]
                : []
            }
          >
            <TextArea
              id="ots_notes"
              className="input-field"
              maxLength={255}
              placeholder={
                action === "Reject"
                  ? "Provide a reason for rejecting this request..."
                  : "Add any additional notes..."
              }
            />
          </FormItem>
        </div>

        <div className="px-4">
          {mode === "edit" && (
            <CrudButtons
              mode={mode}
              recordId={recordData?.ots_id || 0}
              isModal={true}
              modalId={`edit_overtime_request_${action.toLowerCase()}_${recordData?.ots_id}`}
              cancelLabel="Cancel"
              doHideModal={onCancel}
              submitLabel={`${action} Request`}
              submitIcon={submitIcon} 
              moduleId={MODULE_OVERTIME_REQUESTS}
            />
          )}
        </div>
      </Form>
    </div>
  );
};


const mapDispatchToProps = (dispatch) => ({
  doApproval: (data) => dispatch(doOvertimeApproval(data)),
});

export default connect(null, mapDispatchToProps)(OvertimeApprovalForm);
